<template>
  <table class="contest-imports-table">
    <tr>
      <th>Contest</th>
      <th>Import duration</th>
    </tr>
    <tr
      v-for="contestImport in contestImports"
      :key="contestImport.contestId"
    >
      <td>
        <contest-link
          :contestId="contestImport.contestId"
          label="contest"
        />
      </td>
      <td>
        {{contestImport.durationMSec}} msec
      </td>
    </tr>
  </table>
</template>

<script>
import ContestLink from './ContestLink.vue';

export default {
  name: 'ContestImportsTable',

  components: {
    ContestLink,
  },

  props: {
    contestImports: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
.contest-imports-table th,
.contest-imports-table td {
  padding-right: .5rem;
}
</style>